import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../layout/Index'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err) => err)
}

export const constantRouterMap = [
  {
    path: '/login',
    name: 'Login',
    meta: { title: '登录', noCache: true },
    component: (resolve) => require(['@/views/Login'], resolve),
    hidden: true,
  },
  {
    path: '/404',
    component: (resolve) => require(['@/views/features/404'], resolve),
    hidden: true,
  },
  {
    path: '/401',
    component: (resolve) => require(['@/views/features/401'], resolve),
    hidden: true,
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: (resolve) => require(['@/views/features/redirect'], resolve),
      },
    ],
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: (resolve) => require(['@/views/Home'], resolve),
        meta: { title: '首页', icon: 'home', affix: true, noCache: true },
      },
    ],
  },
]

export default new Router({
  fallback: false,
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
})



// WEBPACK FOOTER //
// ./src/router/routers.js